import React from 'react';
import './styles/components.scss';

const RadioButton = ({
  field: { name, value, onChange, onBlur, onClick },
  id,
  label,
  className,
  checked,
  config,
  ...props
}) => {
  
  return (
    <span className='radio-option'>
      <input
        name={name}
        id={id}
        type="radio"
        value={value} 
        checked={value === id}
        onChange={onChange}
        onBlur={onBlur}
        onClick={onClick}
        className="radio-button" 
        // className=''
        {...props}
      />
      <label style={config.page.form.styles.list}  htmlFor={id}>{label}</label>
    </span>
  );
};

export default RadioButton;